module.exports = __webpack_public_path__ + "Roboto-Thin-webfont.1513cc1e17e192e5a03e.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_thin_macroman/Roboto-Thin-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/roboto_thin_macroman/Roboto-Thin-webfont.woff
// module chunks = 1